const SahrawiArabDemocraticRepublicSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112236)">
      <path
        d="M1.98453 11.3046C0.713125 13.9339 0 16.8837 0 20.0002C0 23.1167 0.713125 26.0664 1.98453 28.6958L20 30.435L38.0155 28.6958C39.2869 26.0664 40 23.1167 40 20.0002C40 16.8837 39.2869 13.9339 38.0155 11.3046L20 9.56543L1.98453 11.3046Z"
        fill="#F0F0F0"
      />
      <path
        d="M1.98486 28.6953C5.21971 35.3852 12.0705 39.9997 19.9996 39.9997C27.9288 39.9997 34.7795 35.3852 38.0144 28.6953H1.98486Z"
        fill="#496E2D"
      />
      <path
        d="M1.98486 11.3044H38.0144C34.7795 4.61445 27.9288 0 19.9996 0C12.0704 0 5.21971 4.61445 1.98486 11.3044Z"
        fill="black"
      />
      <path
        d="M5.85785 5.85742C-1.95262 13.6679 -1.95262 26.3312 5.85785 34.1418C9.08543 30.9142 12.1896 27.8101 20 19.9996L5.85785 5.85742Z"
        fill="#D80027"
      />
      <path
        d="M25.2171 20C25.2171 17.0861 27.265 14.6518 29.9997 14.0546C29.5794 13.9629 29.1433 13.9131 28.6954 13.9131C25.3336 13.9131 22.6084 16.6382 22.6084 20C22.6084 23.3618 25.3336 26.087 28.6954 26.087C29.1432 26.087 29.5793 26.0372 29.9997 25.9454C27.265 25.3482 25.2171 22.9139 25.2171 20Z"
        fill="#D80027"
      />
      <path
        d="M30.2563 16.0869L31.1198 18.7443H33.9137L31.6533 20.3863L32.5168 23.0435L30.2563 21.4013L27.9961 23.0435L28.8596 20.3863L26.5991 18.7443H29.3929L30.2563 16.0869Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112236">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SahrawiArabDemocraticRepublicSvg;
